import { FC, useState, useEffect } from "react";

import { Select, Row, Col, Breadcrumb, Button, Tabs, message } from "antd";

import { t, CoreResource } from "shared/plugins/localization";
import { RootState } from "app.store";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import {
  addPromotionCode,
  getPromotionCodeById,
  updatePromotionCode,
} from "states/promotion-code/promotion-code.api";
import { PROMOTION_CODE_ROUTE } from "shared/constants/routes";
import { RollbackOutlined, SaveOutlined } from "@ant-design/icons";
import { PromotionCodeInformationTab } from "./components/promotion-code-information-tab";
import { PromotionCodeConditionTab } from "./components/promotion-code-condition-tab";
import useRefresh from "shared/hooks/use-refresh";
import { setLoading } from "states/global-value/global-value.slice";
import {
  LogicalTermEnum,
  ProductCategoryModel,
} from "states/product-category/product-category.models";
import { getProductCategoryListApi } from "states/product-category/product-category.api";
import { PromotionCodeValueTab } from "./components/promotion-code-value-tab";
import { PromotionCodeModel } from "states/promotion-code/promotion-code.models";
import {
  PromotionConditionModel,
  PromotionConst,
} from "shared/models/promotion.model";

interface IAddUpdatePromotionCodeProps {}
interface RouteParams {
  id: string;
}
const { Option } = Select;
export const AddUpdatePromotionCode: FC<IAddUpdatePromotionCodeProps> = (
  props
) => {
  const params = useParams<RouteParams>();
  const refresh = useRefresh();

  const currentTimeZone = useSelector(
    (state: RootState) => state.globalValue.ianaTimeZone,
    shallowEqual
  );

  const [productCategories, setProductCategories] = useState<
    ProductCategoryModel[]
  >([]);

  const [model, setModel] = useState<PromotionCodeModel>({
    id: "",
    promotion: {
      conditions: [
        {
          type: PromotionConst.promotionConditionType.startDate,
          logicType: LogicalTermEnum.And,
          dateAndTime: new Date(),
        } as PromotionConditionModel,
        {
          type: PromotionConst.promotionConditionType.endDate,
          logicType: LogicalTermEnum.And,
          dateAndTime: new Date(),
        } as PromotionConditionModel,
        {
          type: PromotionConst.promotionConditionType
            .buyAtLeastXProductInListProduct,
          logicType: LogicalTermEnum.And,
          productIds: [],
          numberOfProduct: 1,
        } as PromotionConditionModel,
      ],
      values: [
        {
          type: PromotionConst.promotionValueType.discount,
          discountValue: 0,
          logicType: LogicalTermEnum.Or,
          discountType: PromotionConst.discountType.amount,
          maximumAmountValue: 0,
          productIds: [],
          numberOfGifts: 0,
        },
      ],
    },
  } as PromotionCodeModel);
  const [updateMode, setUpdateMode] = useState<boolean>(false);
  const dispatch = useDispatch();

  const getCategories = async () => {
    const result = await getProductCategoryListApi();
    setProductCategories(result.data);
  };
  const onSaved = async () => {
    dispatch(setLoading(true));
    try {
      if (updateMode) {
        await updatePromotionCode(model);
      } else {
        await addPromotionCode(model);
      }
      dispatch(setLoading(false));
      message.success({
        title: "Thành công",
        content: "Cập nhật thành công",
      });
      refresh();
    } catch (error) {
      message.error({
        title: "Thông báo",
        content: error?.response?.data?.error?.message ?? "Lỗi hệ thống",
      });
      dispatch(setLoading(false));
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const handleGetCurrentPromotion = async () => {
    let promotionCode = await getPromotionCodeById(params?.id);
    setModel(promotionCode.data);
  };
  useEffect(() => {
    if (document.location.href.indexOf("add") > -1) {
      setUpdateMode(false);
      document.title = "Thêm mã khuyến mãi";
    } else {
      setUpdateMode(true);
      handleGetCurrentPromotion();
      document.title = "Cập nhật mã khuyến mãi";
    }
    getCategories();
  }, []);

  return (
    <div className="add-update-promotion-code">
      <Row gutter={[16, 16]} className="mb-4">
        <Col flex="auto">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to={PROMOTION_CODE_ROUTE}>Mã khuyến mãi</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {updateMode ? "Cập nhật" : "Thêm"} {model.code}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col flex="auto" className="d-flex justify-content-end">
          <Link to={PROMOTION_CODE_ROUTE} className="mr-2">
            <Button type="default" icon={<RollbackOutlined />}>
              Trở lại
            </Button>
          </Link>
          <Button onClick={onSaved} type="primary" icon={<SaveOutlined />}>
            Lưu
          </Button>
        </Col>
      </Row>
      <Tabs type="card">
        <Tabs.TabPane tab="Thông tin" key="1">
          <PromotionCodeInformationTab
            model={model}
            onChange={setModel}
            isUpdateMode={updateMode}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Điều kiện áp dụng" key="2">
          <PromotionCodeConditionTab
            model={model}
            onChange={setModel}
            isUpdateMode={updateMode}
            currentTimeZone={currentTimeZone}
            categories={productCategories}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="Giá trị khuyến mãi" key="3">
          <PromotionCodeValueTab
            categories={productCategories}
            model={model}
            onChange={setModel}
            isUpdateMode={updateMode}
            currentTimeZone={currentTimeZone}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};
